interface SubMenu {
	title?: string;
	path?: string;
}
export interface MenuList {
	mainMenu: string;
	subMenu?: SubMenu[];
	mainPath?: string;
}

export interface MypageMenuList {
	menu: string;
	path: string;
}
export const menuList: MenuList[] = [
	{
		mainMenu: '학회소개',
		mainPath: '',
		subMenu: [
			{
				title: '인사말',
				path: '/introduce',
			},
			{
				title: '학회연혁',
				path: '/introduce',
			},
			{
				title: '임원 및 위원회',
				path: '/introduce',
			},
			{
				title: '학회회칙',
				path: '/introduce',
			},
		],
	},
	{
		mainMenu: '회원안내',
		mainPath: '',
		subMenu: [
			{
				title: '회원가입 안내',
				path: '/membership',
			},
			{
				title: '회원가입',
				path: '/membership',
			},
			{
				title: '회비안내',
				path: '/membership',
			},
			{
				title: '연회비 납부',
				path: '/membership',
			},
		],
	},
	{
		mainMenu: '학술대회',
		mainPath: '',
		subMenu: [
			{
				title: '학술대회 안내',
				path: '/conference',
			},
			{
				title: '지난 학술대회',
				path: '/conference',
			},
		],
	},
	{
		mainMenu: '학회 학술지',
		mainPath: 'link',
		subMenu: [],
	},
	{
		mainMenu: '정보광장',
		mainPath: '',
		subMenu: [
			{
				title: '공지사항',
				path: '/infoplace',
			},
			{
				title: '소식지',
				path: '/infoplace',
			},
			{
				title: '연구동향',
				path: '/infoplace',
			},
			{
				title: '갤러리',
				path: '/infoplace',
			},
		],
	},
];

export const mypageMenuList: MypageMenuList[] = [
	{
		menu: '기본정보',
		path: '/mypage/basic',
	},
	{ menu: '직장정보', path: '/mypage/company' },
	{ menu: '학력정보', path: '/mypage/education' },
	{ menu: '기타정보', path: '/mypage/etc' },
	{ menu: '비밀번호 변경', path: '/mypage/password' },
	{ menu: '서비스 이용약관', path: '/mypage/term/service' },
	{ menu: '개인정보 처리방침', path: '/mypage/term/privacy' },
];

export const CONF_TITLE = '2026년 한국노화학회 추계학술대회';
export const CONF_TITLE_MAIN = '2026년 한국노화학회\n추계학술대회';
export const CONF_PLACE = '서울특별시 송파구 올림픽로 43길 88 서울아산병원 동관6층 제2세미나실';
export const CONF_DATE = '2026년 10월 23일(금)';
export const CONF_DATE_SUB = '2026년 8월 31일(월) – 10월 16일(금)';
export const CONF_TITLE_SUB =
	'2026년 (사)한국노인과학학술단체연합회 학술대회 & 한국노화학회 추계학술대회 <br />초고령사회의 새로운 패러다임: 디지털 전환과 AI 기반 혁신';
